<template>
  <b-overlay
    :show="show"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <!-- <b-card-text>Device.</b-card-text> -->
    <validation-observer ref="simpleRules">
      <b-form @submit.prevent>
        <b-card title="Master Device">
          <b-row>
            <!-- Device -->
            <b-col cols="12">
              <b-form-group
                label="Device"
                label-for="v-Device"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Device"
                  rules="required"
                >
                  <v-select
                    id="v-Device"
                    v-model="form.device"
                    placeholder="Choose Device to Replace"
                    autocomplete="off"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="code"
                    :options="items"
                    :reduce="items => items.id"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Type -->
            <b-col cols="12">
              <b-form-group
                label="Type"
                label-for="v-Type"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Type"
                  rules="required"
                >
                  <v-select
                    id="v-Type"
                    v-model="form.select_1"
                    placeholder="Chose Type"
                    autocomplete="off"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :options="TypeOptions"
                    :reduce="TypeOptions => TypeOptions.value"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Name -->
            <b-col cols="12">
              <b-form-group
                label="Name"
                label-for="v-Name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Name"
                  rules="required"
                >
                  <b-form-input
                    id="v-Name"
                    v-model="form.text_2"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Name"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Kode -->
            <b-col cols="12">
              <b-form-group
                label="Kode"
                label-for="v-Kode"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Kode"
                  rules="required"
                >
                  <b-form-input
                    id="v-Kode"
                    v-model="form.text_2"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Kode"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Note -->
            <b-col cols="12">
              <b-form-group
                label="Note"
                label-for="v-Note"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Note"
                  rules="required"
                >
                  <b-form-textarea
                    id="v-Note"
                    v-model="form.textarea_1"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Note"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Serial Number -->
            <b-col cols="12">
              <b-form-group
                label="Serial Number"
                label-for="v-Serial Number"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Serial Number"
                  rules="required"
                >
                  <b-input-group>
                    <b-form-input
                      id="v-Serial Number"
                      v-model="form.text_3"
                      type="number"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Serial Number"
                    />
                    <b-input-group-append>
                      <b-button
                        variant="outline-primary"
                        @click="checkBySerialNumber()"
                      >
                        Check
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <small :class="serialclass">{{ serial }}</small>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click.prevent="validationForm"
              >
                Submit
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-form>
    </validation-observer>
  </b-overlay>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BOverlay, BInputGroupAppend, BInputGroup, BCardText, BFormFile, BMediaBody, BMedia, BMediaAside, BLink, BCol, BFormGroup, BFormCheckbox, BFormInput, BFormTextarea, BForm, BButton, BCard, BImg,
} from 'bootstrap-vue'
import { mapState } from 'vuex'
import { required } from '@validations'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router/index.js'

export default {
  components: {
    vSelect, BOverlay, BInputGroupAppend, BInputGroup, BCardText, BFormFile, BMediaBody, BMedia, BMediaAside, BLink, BFormCheckbox, ValidationProvider, ValidationObserver, BCard, BImg, BRow, BCol, BFormGroup, BFormInput, BFormTextarea, BForm, BButton,
  },
  directives: { Ripple },
  data() {
    return {
      form: {
        id: null, device: null, select_1: null, textarea_1: '', text_1: '', text_2: '', text_3: '', text_4: '', text_5: '', text_6: '', checkbox_1: false, imageUrl: require('@/assets/images/icons/jpg.png'), setImage: 'none', logo: null, latitude: '', longitude: '',
      },
      serialclass: null,
      serial: null,
      show: false,
      params: {},
      required,
    }
  },
  computed: {
    ...mapState({
      items: state => state.device.items,
      TypeOptions: state => state.type.options,
      SiteOptions: state => state.site.options,
      ProvinceOptions: state => state.region.province,
      RegencyOptions: state => state.region.regency,
      DistrictOptions: state => state.region.district,
    }),
  },
  created() {
    this.params = {
      province_id: '',
      regency_id: '',
      district_id: '',
      site_id: '',
      device_type_id: '',
      status: '',
    }

    this.$store.dispatch('device/getAll')
    this.$store.dispatch('type/getAll')
    this.$store.dispatch('region/province')
  },
  mounted() {
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
  },
  methods: {
    async validationForm() {
      this.show = true
      console.log(this.form)
      try {
        const isValid = await this.$refs.simpleRules.validate()
        if (isValid) {
          const postData = {
            replace_device_id: this.form.device,
            type: this.form.select_1,
            name: this.form.text_2,
            code: this.form.text_2,
            note: this.form.textarea_1,
            serial_number: this.form.text_3,
            installator_id: JSON.parse(localStorage.getItem('userData')).id ?? 0,
            // latitude: this.form.latitude,
            // longitude: this.form.longitude
          }

          const headers = {
            authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          }

          await axios.post(`${process.env.VUE_APP_DEVICE_API}/devices/replace`, postData, { headers })
          this.show = false
          this.notification('Success', 'CheckIcon', 'success', 'You have successfully Registered Assets')
          router.push({ name: 'project-device' })
        } else {
          console.error('VALIDATION ERROR:') // Log the validation error
          this.show = false
          this.notification('Failed', 'CloseIcon', 'danger', 'Validation error occurred')
        }
      } catch (err) {
        console.error('VALIDATION ERROR:', err) // Log the validation error
        this.show = false
        this.notification('Failed', 'CloseIcon', 'danger', 'Validation error occurred')
      }
    },
    notification(a, b, c, d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: a, icon: b, variant: c, text: d,
        },
      })
    },
    checkBySerialNumber() {
      this.$store.dispatch('device/checkBySerialNumber', this.form.text_3).then(data => {
        if (data.message === 'SUCCESS') {
          this.serialclass = 'text-success'
        } else {
          this.serialclass = 'SUCCESS'
        }
        this.serial = data.message
      })
    },
    getData(id) {
      this.$store.dispatch('device/getById', id).then(data => {
        this.form = data
        this.form.id = data.id
        this.form.select_1 = data.device_type_id
        this.form.text_2 = data.code
        this.form.text_2 = data.name
        this.form.textarea_1 = data.note
        this.form.text_3 = data.serial_number
        this.form.latitude = data.latitude
        this.form.longitude = data.longitude
        this.serial = 'SUCCESS'
        this.show = false
      })
    },
  },
}
</script>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>
